module.exports = {"data":{"allMarkdownRemark":{"edges":[{"node":{"html":"","frontmatter":{"name":"Holzauge Fotografie","address":"Schloßstraße 6, 50226 Frechen","mail":"info@holzauge-fotografie.de","phone":"015233589432"}}}]}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/contact.json
// module id = 396
// module chunks = 184662623972074